































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Agency from "@/store/entities/agency";
import Airport from "@/store/entities/flight/airport";
import moment from "moment";

@Component({
})
export default class FlightSearch extends Vue {
  adultCount: number = 1;
  childCount: number = 0;
  infantCount: number = 0;
  menu: boolean = false;
  isLoading: boolean = false;
  currencyItems:any[]=[];
  selectCurrency:any={};
  startDate: string = null;
  startDateMenu: boolean = false;
  endDate: string = null;
  endDateMenu: boolean = false;
  agencies: Agency[] = [];
  airports: Airport[] = [];
  fromAirport: Airport
  toAirport: Airport
   
  changeCurrency(){
      this.$store.state.app.selectCurrencyId=this.selectCurrency.name;
  }

  get getStartDate() {
    return this.startDate
      ? moment(this.startDate).format("DD-MM-yyyy")
      : moment().format("DD-MM-yyyy");
  }

  get getEndDate() {
    return this.endDate
      ? moment(this.endDate).format("DD-MM-yyyy")
      : moment()
          .add(1, "days")
          .format("DD-MM-yyyy");
  }

  get getMinEndDate() {
    return this.startDate
      ? moment(this.startDate)
          .add(2, "days")
          .toISOString()
          .slice(0, 10)
      : "";
  }

    createdCurrency(){
      this.selectCurrency={ name: 'TRY' };
      this.currencyItems=[
          { name: 'TRY' },
          { name: 'USD' },
          { name: 'RUB' },
          { name: 'EUR' },
        ]
    }

    


  async created() {
    this.getAgency();
    this.createdCurrency();
    this.getAirports();
  }

  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });

    this.agencies = this.$store.state.agency.list;
  }

  async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
    });

    this.airports = this.$store.state.airport.list;
  }



  get totalPassengerCount() {
    return this.adultCount + this.childCount + this.infantCount;
  }

  plusAdultCount() {
    if (this.adultCount < 9) this.adultCount += 1;
  }

  minusAdultCount() {
    if (this.adultCount != 1) this.adultCount -= 1;
  }

  plusChildCount() {
    if (this.childCount < 9) this.childCount += 1;
  }
  minusChildCount() {
    if (this.childCount != 0) this.childCount -= 1;
  }
  plusInfantCount() {
    if (this.infantCount < 9) this.infantCount += 1;
  }
  minusInfantCount() {
    if (this.infantCount != 0) this.infantCount -= 1;
  }
}

